export const mergeFunctionsReturnType = <A extends any, R1, R2>(condition: boolean, f1: (a: A) => R1, f2: (a: A) => R2): ((a: A) => R1 | R2) => {
  if (condition) return f1
  return f2
}
